/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vpn_Exclusive_MessageInputs */

const en_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN is available exclusively in the Brave browser.`)
};

const id_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN tersedia secara eksklusif di browser Brave.`)
};

const ms_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN tersedia secara eksklusif di penyemak imbas Brave.`)
};

const ca_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La VPN de Brave només està disponible al navegador de Brave.`)
};

const cs_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN je k dispozici výhradně v prohlížeči Brave.`)
};

const da_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN er udelukkende tilgængelig i Brave-browseren.`)
};

const de_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN ist ausschließlich im Brave Browser verfügbar.`)
};

const et_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN on saadaval ainult Brave'i brauseris.`)
};

const es_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN está disponible exclusivamente en el navegador de Brave.`)
};

const fr_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le VPN Brave est disponible exclusivement dans le navigateur Brave.`)
};

const hr_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN dostupan je ekskluzivno u pregledniku Brave.`)
};

const it_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN è disponibile esclusivamente con il browser di Brave.`)
};

const lv_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN ir pieejams tikai Brave pārlūkā.`)
};

const lt_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`„Brave“ virtualusis privatusis tinklas prieinamas tik „Brave“ naršyklėje.`)
};

const hu_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Brave VPN kizárólag a Brave böngészőben érhető el.`)
};

const nl_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN is exclusief beschikbaar in de Brave-browser.`)
};

const nb_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN er kun tilgjengelig i Braves nettleser.`)
};

const pl_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funkcja Brave VPN jest dostępna wyłącznie w przeglądarce Brave.`)
};

const pt_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A VPN Brave está disponível exclusivamente no navegador Brave.`)
};

const ro_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN este disponibil exclusiv în browserul Brave.`)
};

const sk_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN je k dispozícii výlučne v prehliadači Brave.`)
};

const sl_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN je na voljo izključno v brskalniku Brave.`)
};

const fi_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN on saatavilla ainoastaan Brave-selaimessa.`)
};

const sv_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN är endast tillgängligt i Brave-webbläsaren.`)
};

const vi_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN chỉ có trên trình duyệt Brave.`)
};

const tr_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN yalnızca Brave tarayıcısında kullanılabilir.`)
};

const el_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Το Brave VPN είναι διαθέσιμο αποκλειστικά στο πρόγραμμα περιήγησης Brave.`)
};

const bg_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN се предлага изключително в браузъра Brave.`)
};

const ru_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN доступен исключительно в браузере Brave.`)
};

const sr_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN је доступан искључиво у Brave прегледачу.`)
};

const uk_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN доступний виключно в браузері Brave.`)
};

const ka_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN ექსკლუზიურად Brave ბრაუზერშია ხელმისაწვდომი.`)
};

const hi_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ब्रेव वीपीएन केवल ब्रेव ब्राउज़र में उपलब्ध है।`)
};

const th_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN มีให้บริการเฉพาะในเบราว์เซอร์ Brave เท่านั้น`)
};

const ko_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN은 Brave 브라우저에서만 사용할 수 있습니다.`)
};

const zh_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN 仅在 Brave 浏览器中提供。`)
};

const zh_tw_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN 僅限於 Brave 瀏覽器中使用。`)
};

const ja_vpn_exclusive_message = /** @type {(inputs: Vpn_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN はBraveブラウザでのみ利用できます。`)
};

/**
* | output |
* | --- |
* | "Brave VPN is available exclusively in the Brave browser." |
*
* @param {Vpn_Exclusive_MessageInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const vpn_exclusive_message = /** @type {((inputs?: Vpn_Exclusive_MessageInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vpn_Exclusive_MessageInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_vpn_exclusive_message(inputs)
	if (locale === "ms") return ms_vpn_exclusive_message(inputs)
	if (locale === "ca") return ca_vpn_exclusive_message(inputs)
	if (locale === "cs") return cs_vpn_exclusive_message(inputs)
	if (locale === "da") return da_vpn_exclusive_message(inputs)
	if (locale === "de") return de_vpn_exclusive_message(inputs)
	if (locale === "et") return et_vpn_exclusive_message(inputs)
	if (locale === "es") return es_vpn_exclusive_message(inputs)
	if (locale === "fr") return fr_vpn_exclusive_message(inputs)
	if (locale === "hr") return hr_vpn_exclusive_message(inputs)
	if (locale === "it") return it_vpn_exclusive_message(inputs)
	if (locale === "lv") return lv_vpn_exclusive_message(inputs)
	if (locale === "lt") return lt_vpn_exclusive_message(inputs)
	if (locale === "hu") return hu_vpn_exclusive_message(inputs)
	if (locale === "nl") return nl_vpn_exclusive_message(inputs)
	if (locale === "nb") return nb_vpn_exclusive_message(inputs)
	if (locale === "pl") return pl_vpn_exclusive_message(inputs)
	if (locale === "pt") return pt_vpn_exclusive_message(inputs)
	if (locale === "ro") return ro_vpn_exclusive_message(inputs)
	if (locale === "sk") return sk_vpn_exclusive_message(inputs)
	if (locale === "sl") return sl_vpn_exclusive_message(inputs)
	if (locale === "fi") return fi_vpn_exclusive_message(inputs)
	if (locale === "sv") return sv_vpn_exclusive_message(inputs)
	if (locale === "vi") return vi_vpn_exclusive_message(inputs)
	if (locale === "tr") return tr_vpn_exclusive_message(inputs)
	if (locale === "el") return el_vpn_exclusive_message(inputs)
	if (locale === "bg") return bg_vpn_exclusive_message(inputs)
	if (locale === "ru") return ru_vpn_exclusive_message(inputs)
	if (locale === "sr") return sr_vpn_exclusive_message(inputs)
	if (locale === "uk") return uk_vpn_exclusive_message(inputs)
	if (locale === "ka") return ka_vpn_exclusive_message(inputs)
	if (locale === "hi") return hi_vpn_exclusive_message(inputs)
	if (locale === "th") return th_vpn_exclusive_message(inputs)
	if (locale === "ko") return ko_vpn_exclusive_message(inputs)
	if (locale === "zh") return zh_vpn_exclusive_message(inputs)
	if (locale === "zh-tw") return zh_tw_vpn_exclusive_message(inputs)
	if (locale === "ja") return ja_vpn_exclusive_message(inputs)
	return en_vpn_exclusive_message(inputs)
});